import { render, staticRenderFns } from "./customer-order-priceChange.vue?vue&type=template&id=32423182&scoped=true"
import script from "./customer-order-priceChange.vue?vue&type=script&lang=js"
export * from "./customer-order-priceChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32423182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32423182')) {
      api.createRecord('32423182', component.options)
    } else {
      api.reload('32423182', component.options)
    }
    module.hot.accept("./customer-order-priceChange.vue?vue&type=template&id=32423182&scoped=true", function () {
      api.rerender('32423182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stat-analyze/customer-analyze/customer-order-priceChange.vue"
export default component.exports